<script>
import { BBreadcrumbItem } from "bootstrap-vue";

export default {
  extends: BBreadcrumbItem
};
</script>